<div class="layer-legend-list-container">
  @if (layersInUi().length && allowShowAllLegends()) {
    <mat-slide-toggle
      tooltip-position="above"
      matTooltipShowDelay="500"
      [matTooltip]="'igo.geo.layer.legend.showAll' | translate"
      [checked]="showAllLegendsValue()"
      [labelPosition]="'before'"
      (change)="toggleShowAllLegends($event.checked)"
    >
      {{ 'igo.geo.layer.legend.showAll' | translate }}
    </mat-slide-toggle>
  }
  @if (layersInUi().length && allowShowAllLegends()) {
    <mat-divider />
  }
  <igo-list [navigation]="false" [selection]="false">
    @for (layer of layersLegend(); track layer; let i = $index) {
      @if (!(excludeBaseLayers() && isLayerItem(layer) && layer.baseLayer)) {
        <igo-layer-legend-item
          igoListItem
          [layer]="$any(layer)"
          [updateLegendOnResolutionChange]="updateLegendOnResolutionChange()"
        />
      }
    }
  </igo-list>
  @if (
    !showAllLegendsValue() &&
    layersInUi().length &&
    hasVisibleOrInRangeLayers() === false &&
    hasVisibleAndNotInRangeLayers() === false &&
    allowShowAllLegends()
  ) {
    <p class="layers-empty">
      {{ 'igo.geo.layer.legend.noLayersVisibleWithShowAllButton' | translate }}
    </p>
  }
  @if (
    !showAllLegendsValue() &&
    layersInUi().length &&
    hasVisibleOrInRangeLayers() === false &&
    hasVisibleAndNotInRangeLayers() &&
    allowShowAllLegends()
  ) {
    <p class="layers-empty">
      {{
        'igo.geo.layer.legend.noLayersVisibleWithShowAllButtonButZoom'
          | translate
      }}
    </p>
  }
  @if (
    layersInUi().length &&
    hasVisibleOrInRangeLayers() === false &&
    hasVisibleAndNotInRangeLayers() === false &&
    !allowShowAllLegends()
  ) {
    <p class="layers-empty">
      {{ 'igo.geo.layer.legend.noLayersVisible' | translate }}
    </p>
  }
  @if (
    layersInUi().length &&
    hasVisibleOrInRangeLayers() === false &&
    hasVisibleAndNotInRangeLayers() &&
    !allowShowAllLegends()
  ) {
    <p class="layers-empty">
      {{ 'igo.geo.layer.legend.noLayersVisibleButZoom' | translate }}
    </p>
  }
</div>
